import { Form, FormInstance, Input, message, Select } from 'antd';
import { AxiosResponse } from 'axios';
import { Row } from 'components/Box/Row';
import MyQuillComponent from 'components/Modal/MyQuillComponentProps';
import useGetAllStore from 'pages/package-sms/services/hooks/useGetAllStore';
import { ERequestPriority, RequestPriorityOptions, RequestSupportStatusOptions } from 'pages/request-support/services/constants';
import useGetAllEmployees from 'pages/request-support/services/hooks/useGetAllEmployees';
import requestSupportApis from 'services/requestSupportApis';
import styled from 'styled-components';

interface Props {
  form: FormInstance<RequestFormValues>;
  onClose?: () => void;
  refetch?: () => void;
}

export interface RequestFormValues {
  id?: string;
  shopId: string;
  assignId: string;
  status: string;
  title: string;
  description: string;
  priority: ERequestPriority;
}

const RequestForm = ({ form, onClose, refetch }: Props) => {
  const { data: allStore } = useGetAllStore();
  const { data: employees } = useGetAllEmployees();

  const storeOptions =
    allStore?.map((store) => ({
      label: `${store.shopName}, ${store.address} ${store.city} ${store.state} ${store.zipCode}`,
      value: store.shopId,
    })) || [];

  const employeeOptions =
    employees?.map((employee) => ({
      label: employee.name,
      value: employee.id,
    })) || [];

  const handleSubmit = async (values: RequestFormValues) => {
    try {
      const res: AxiosResponse = await requestSupportApis.modifyRequestSupport({
        id: values.id || '',
        ...values,
      });

      if (res?.data) {
        message.success('Support ticket updated successfully');
        refetch?.();
        onClose?.();
      }
    } catch (error) {
      message.error('Failed to update support ticket');
    }
  };

  return (
    <Container>
      <Form layout='vertical' className='request-form' form={form} onFinish={handleSubmit} initialValues={{  priority: ERequestPriority.MEDIUM }}>
        <Form.Item name='id' hidden noStyle>
          <Input/>
        </Form.Item>
        <Form.Item label='SALON' name='shopId'>
          <Select 
            placeholder='Select salon' 
            options={storeOptions} 
            className='custom-select' 
            showSearch
            optionFilterProp='label'
          />
        </Form.Item>
        <Row style={{ gap: 16 }}>
          <Form.Item label='ASSIGN' name='assignId' style={{ flex: 1 }}>
            <Select placeholder='Select assign' options={employeeOptions} className='custom-select' />
          </Form.Item>
          <Form.Item label='STATUS' name='status' style={{ flex: 1 }}>
            <Select placeholder='Select status' options={RequestSupportStatusOptions} className='custom-select' />
          </Form.Item>
          <Form.Item label='PRIORITY' name='priority' style={{ flex: 1 }}>
            <Select placeholder='Select priority' options={RequestPriorityOptions} className='custom-select' />
          </Form.Item>
        </Row>
        <Form.Item label='TITLE' name='title'>
          <Input placeholder='Title' className='custom-input' />
        </Form.Item>
        <Form.Item label='CONTENT' name='description'>
          <MyQuillComponent />
        </Form.Item>
      </Form>
    </Container>
  );
};

export default RequestForm;

const Container = styled.div`
  .request-form {
    .ant-form-item-label > label {
      font-weight: 500;
      font-size: 14px;
      font-family: 'Poppins';
      color: #566a7f;
    }

    .ant-form-item {
      margin-bottom: 16px;
    }
  }

  .custom-select {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    background: #fff;

    .ant-select-selector {
      border-radius: 8px;
      border: 1px solid #c9cdd4;

      .ant-select-selection-search-input {
        height: 100%;
      }
    }
  }

  .custom-input {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #c9cdd4;
  }

  .ql-editor {
    min-height: 200px !important;
  }
`;
